var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassStatusStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#13BD7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 1.75,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    fill: "#13BD7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9555 8.64641L18.81 9.79178L19.275 10.2567C19.3556 10.3335 19.4198 10.4259 19.4637 10.5283C19.5076 10.6306 19.5302 10.7408 19.5302 10.8522C19.5302 10.9636 19.5076 11.0738 19.4637 11.1762C19.4198 11.2785 19.3556 11.3709 19.275 11.4477L11.6187 19.1039H8.89648V16.3817L16.5527 8.72548C16.6295 8.6448 16.7219 8.58057 16.8243 8.53669C16.9266 8.4928 17.0368 8.47017 17.1482 8.47017C17.2596 8.47017 17.3698 8.4928 17.4722 8.53669C17.5745 8.58057 17.6669 8.6448 17.7437 8.72548L18.2087 9.19034L19.354 8.04492L19.9555 8.64641ZM9.74718 18.2533H11.2784L18.6795 10.8522L17.1482 9.32096L9.74718 16.722V18.2533ZM11.0234 12.1224L14.2501 8.89574L14.8516 9.49721L11.6249 12.7239L11.0234 12.1224Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassStatusStart);
export default __webpack_public_path__ + "static/media/class-status-start.34e5966f76b58952748acfe3cf50a337.svg";
export { ForwardRef as ReactComponent };